






































import { Component, Vue, Watch } from 'vue-property-decorator'
import { AloForfait } from '@/models/alo/AloForfait'
import { getImageUrl } from '@/utils/images'
import { toNumberDictionary } from '@/utils/groupBy'

const searchSensibility = 300

@Component({
  name:"PiscineListItem",
  components: {    
  },
  props:{
    forfaits:Array,
    allowedAcyIds:Array,
    acyIdsWithCours:Array,
    domicile:{
      type:Boolean,
      default:false
    }
  }
})
export default class PiscineListItem extends Vue {
  forfaits!:Array<AloForfait>
  allowedAcyIds!:Array<number>
  acyIdsWithCours!:Array<number>

  get getImageUrl(){ 
    return getImageUrl
  }

  get activityDic(){
    return this.$store.myGetters.activityDic
  }



  get activityDictWithCours(){
    return toNumberDictionary(this.acyIdsWithCours,id => id)
  }

  get itemPanierDicByForfait() {
    return toNumberDictionary(this.$store.myGetters.panier.items,it=> it.item.id)
  }

  isBlackFriday(name:string) {
    return (name ?? '').toLowerCase().indexOf("black friday") > -1  
  }


  tarifAuCours(fft:AloForfait):number {    
    return fft.fftIsAbo?(fft.fftTarif! * fft.fftValiditeM!) / ((52 * fft.fftNbEntree! * fft.fftValiditeM!) / 12):fft.fftTarif!/fft.fftNbEntree!
  }  
  


}
